<template>
    <div class="sw-modal confirm-dialog">
        <div v-click-outside="cancelAction" class="sw-modal-content">
            <div class="row sw-modal-heading">
                <div class="col">
                    <h4>Duplicate Automation</h4>
                </div>
            </div>
            <div class="sw-modal-body">
                <div class="row">
                    <div class="col-12">
                        <span v-html="message"></span>
                    </div>
                </div>
                <div v-if="hasMultipleEstablishments" class="row confirm-dialog__duplicate_to">
                    <div class="col-4 text-right">
                        Copy to:
                    </div>
                    <div class="col-8 text-left question mb-0">
                        <select v-model="establishmentReference">
                            <option v-for="(establishment, index) in getEstablishments" v-bind:key="index" v-bind:value="establishment.reference">
                                {{establishment.name}}
                            </option>
                        </select>
                    </div>
                </div>
                <div class="sw-modal-actions">
                    <div class="row">
                        <div class="col text-center">
                            <button v-if="!hideCancelButton" class="btn btn-normal" v-on:click.stop="cancelAction()">{{cancelButtonText}}</button>
                            <button class="btn btn-primary" v-on:click.stop="continueAction()">{{continueButtonText}}</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { store, getters } from '../../store.js'

    export default {
        name: 'ConfirmDuplicateAutomationDialog',
        components: {
        },
        props: {
            message: String,
            callbackName: String,
            callbackReference: String,
            continueText: String,
            cancelText: String,
            hideCancelButton: Boolean
        },
        data: function() {
            return {
                establishmentReference: null,
                canCancel: false,
            }
        },
        computed: {
            hasMultipleEstablishments: function() {
                return getters.hasMultipleEstablishments();
            },
            getEstablishments: function() {
                return store.host.establishments;
            },
            continueButtonText: function() {
                if (this.continueText) {
                    return this.continueText;
                } else {
                    return "Continue"
                }
            },
            cancelButtonText: function() {
                if (this.cancelText) {
                    return this.cancelText;
                } else {
                    return "Cancel"
                }
            }
        },
        methods: {
            cancelAction: function() {
                if (this.canCancel) {
                    console.log("cancel");
                    this.$root.$emit(this.callbackName);
                }
            },
            continueAction: function() {
                console.log("continue primary");
                this.$root.$emit(this.callbackName, this.callbackReference, this.establishmentReference);
            },
        },
        mounted() {
            this.establishmentReference = store.currentEstablishmentReference;
            setTimeout(() => {
                this.canCancel = true;
            }, 500);
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../styles/components/modal.scss";
    @import "../../styles/components/question_answer.scss";
    @import "../../styles/components/confirm_dialog.scss";
</style>